import { Divider, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface IrrigationCellDisplayProps {
  value: any
}

export const IrrigationCellDisplay = ({ value }: IrrigationCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/IrrigationEditor')

  const hasInputData = !!(
    value?.input?.rate ||
    value?.input?.irrigationType ||
    value?.input?.schedule
  )
  const irrigated = value?.result !== undefined ? value.result : hasInputData

  return (
    <Stack>
      <Typography>
        {!irrigated
          ? t('no')
          : !!value?.input?.rate && value?.input?.units
          ? `${value.input?.rate} ${t('unit', { context: value.input?.units })}`
          : t('yes')}
      </Typography>

      <Stack direction="row" spacing={1} divider={<Divider orientation="vertical" flexItem />}>
        {!!value?.input?.irrigationType && (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {t('type', { context: value.input.irrigationType })}
          </Typography>
        )}
        {!!value?.input?.schedule && (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {t('schedule', { context: value.input.schedule })}
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}
